import { Button } from '@lmig/lmds-react-button';
import { useEffect, useState } from 'react';
import './HorizontalCreditPerk.scss';
import { triggerGoal } from 'Utilities/GoalManager';
import UpdateObjectCTA from './UpdateObjectCTA';
import { IHorizontalCreditPerk } from './Models/HorizontalPerkModels';

const HorizontalCreditPerk = (props: IHorizontalCreditPerk) => {
  const [renderButton, setRenderButton] = useState(false);
  const [renderCTA, setRenderCTA] = useState(false);

  const richText = props.richText
    ?.replace('&lsquo;', "'")
    .replace('&rsquo;', "'")
    .concat('<h5>&nbsp;' + props.couponCode + '</h5>');

  useEffect(() => {
    //priority to rendering CTA
    if (props.cta && props.cta.ctaButton && props.cta.rewardId) {
      setRenderCTA(true);
    } else if (props.buttonURL && props.buttonText) {
      setRenderButton(true);
    }
  }, [props.buttonURL, props.buttonText, props.cta]);

  return (
    <div
      className={
        props.oneThirdWidthVariant ? 'horizontal-credit-perk-container-one-third' : 'horizontal-credit-perk-container'
      }
      style={{
        backgroundImage: `url(${
          props.oneThirdWidthVariant
            ? '/-/media/Project/Safeco/shared/Rewards/one-third-background_396x256.jpg'
            : '/-/media/Project/Safeco/shared/Rewards/BL-Horizontal-perk-background_824x110px.jpg'
        })`,
      }}
    >
      <div className="horizontal-credit-perk-content">
        <div className="horizontal-credit-perk-text">
          <div>
            <div
              style={{
                display: 'flex',
                flexFlow: 'row wrap',
                justifyContent: 'space-around',
              }}
              dangerouslySetInnerHTML={{ __html: richText }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexFlow: 'row wrap',
              alignItems: 'baseline',
              justifyContent: 'center',
            }}
          >
            <div className="credit-perk-info">
              <p>Total credit:&nbsp;</p>
              <h5>{props.totalCredit?.split('.')[0]}&nbsp;&nbsp;&nbsp;</h5>
            </div>
            <div className="credit-perk-info">
              <p>Remaining:&nbsp;</p>
              <h5>{props.amountAvailable?.split('.')[0]}</h5>
            </div>
          </div>
        </div>
        {renderButton && (
          <div className="horizontal-credit-perk-button">
            <Button
              size="small"
              variant="primary"
              href={props.buttonURL}
              onClick={() => triggerGoal(props.buttonGoal)}
              alt={props.buttonText}
              data-testid={props.couponCode}
              target={props.linkTarget}
            >
              {props.buttonText}
            </Button>
          </div>
        )}
        {renderCTA && (
          <div className="horizontal-credit-perk-button">
            <UpdateObjectCTA
              modalText={props.cta.modalText}
              closeButton={props.cta.closeButton}
              closeButtonGoal={props.cta.closeButtonGoal}
              ctaButton={props.cta.ctaButton}
              ctaButtonGoal={props.cta.ctaButtonGoal}
              rewardId={props.cta.rewardId}
              modalTitle={props.cta.modalTitle}
              size={'small'}
            ></UpdateObjectCTA>
          </div>
        )}
      </div>
    </div>
  );
};
export default HorizontalCreditPerk;
